<template>
	<div class="pageContainer app-container studentContainer" style="position: relative;">


		<el-tabs v-model="activeName" type="card" style="" @tab-click="changeTab">
			<el-tab-pane label="" name="td">
				<span slot="label">
					<i class="el-icon-s-release">退档申请</i>
					<!-- <el-badge :value="td_count" v-if="td_count>0" size="mini" class="item"></el-badge> -->
				</span>
			</el-tab-pane>
			
		</el-tabs>

		<el-table stripe :data="dataList" style="width: 100%;margin-bottom: 20px; color: #000;" border size="mini">
			<el-table-column type="index" label="序号" width="60"></el-table-column>
			<el-table-column prop="stu_name" label="姓名" min-width="80"></el-table-column>

			<el-table-column prop="archive" label="建档号" min-width="100"></el-table-column>
			<el-table-column prop="exam_num" label="考试号" min-width="100"></el-table-column>
			<el-table-column prop="phone" label="联系电话" min-width="100"></el-table-column>
			<el-table-column prop="from_major" label="当前专业" min-width="120"></el-table-column>
			<el-table-column prop="to_major" v-if="activeName=='zzy'" label="转至专业" min-width="120"></el-table-column>
			<el-table-column prop="cdate" label="申请日期" min-width="120"></el-table-column>
			<!-- <el-table-column prop="status" label="审核状态" min-width="120">
				<template slot-scope="scope">
					<span v-if="scope.row.status==1" style="color: #007AFF;">审核通过</span>
					<span v-if="scope.row.status==9" style="color: orangered;">审核不通过</span>
					<span v-if="scope.row.status==0">未审核</span>
				</template>
			</el-table-column> -->
			<el-table-column fixed="right" label="操作" width="150">
				<template slot-scope="scope">
					<div class="flexStart">


						<el-button v-if="scope.row.status==0&&false" type="text" size="small" icon="el-icon-document-checked"
							@click="showSPDialog(scope.row)" style="margin: 0!important;">审核
						</el-button>


						<el-button v-if="scope.row.status==0" type="text" size="small" icon="el-icon-printer"
							style="margin: 0 0 0 10px!important;" @click="formData=scope.row; showPrint=true">打印
						</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>

		<!--    审核-->
		<el-dialog title="审核" width="800px" :visible.sync="showSP" :close-on-click-modal="false">
			<el-card class="box-card">
				<div slot="header" class="clearfix">
					<span>基本信息</span>

				</div>

				<el-form :model="formData" inline ref="adminUserInfo" label-width="100px">
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="建档号" prop="archive">{{formData.archive}}</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="考试证号" prop="exam_num">{{formData.exam_num}}
							</el-form-item>
						</el-col>
					</el-row>


					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="学生姓名" prop="stu_name">{{formData.stu_name}}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="身份证号" prop="identity_card">{{formData.identity_card}}
							</el-form-item>
						</el-col>

					</el-row>


					<el-col :span="12">
						<el-form-item label="联系方式" prop="phone">{{formData.phone}}
						</el-form-item>
					</el-col>


					<el-col :span="12">

						<el-form-item label="当前专业" prop="remark">{{formData.from_major}}
						</el-form-item>
					</el-col>

					<el-col :span="12" v-if="activeName=='zzy'">

						<el-form-item label="转至专业" prop="remark">{{formData.to_major}}
						</el-form-item>
					</el-col>

					<el-col :span="24">

						<el-form-item label="申请理由" prop="remark">{{formData.sq_reason}}
						</el-form-item>
					</el-col>

					<el-col :span="12">

						<el-form-item label="学生签名" prop="remark">
							<img :src="formData.stu_sign" v-if="formData.stu_sign" style="width: 200px;">
						</el-form-item>
					</el-col>


					<el-col :span="12">

						<el-form-item label="监护人签名" prop="remark">
							<img :src="formData.stu_parent_sign" v-if="formData.stu_parent_sign" style="width: 200px;">
						</el-form-item>
					</el-col>

				</el-form>

			</el-card>


			<div style="height: 10px;"></div>

			<el-row class="flexEnd">

				<el-input style="margin-right: 20px;" v-model="spword" size="small" placeholder="请输入审核不通过原因"></el-input>

				<el-button size="small" type="default" @click="handleCancel" icon="el-icon-back">取消</el-button>

				<el-button size="small" type="primary" @click="checkSubmit(9)" icon="el-icon-close">审核不通过</el-button>
				<el-button size="small" type="primary" @click="checkSubmit(1)" icon="el-icon-check">审核通过</el-button>
			</el-row>
		</el-dialog>
		<!--打印-->


		<el-dialog title="打印申请表" width="800px" :visible.sync="showPrint" :close-on-click-modal="false">
			<div style="float: right;">
				<el-button size="small" type="default" @click="printIframe"
					icon="el-icon-printer">打印</el-button>
			</div>
			<iframe :src="'./h5/'+formData.form_type+'.html?id='+formData.id+'&pmid='+formData.pmid" id="printPage"
				style="width: 100%; height:600px; border: 0;"></iframe>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				td_count: 0,
				zzy_count: 0,
				activeName: 'td',
				dataList: [],
				showSP: false,
				formData: {},
				spword: '',
				showPrint: false
			}
		},
		mounted() {
			this.getlist()
		},
		methods: {
			getlist() {
				this.$http.post("/api/t_sch_stu_apforms_list", {
					page: 1,
					pagesize: 1000,
					form_type: this.activeName
				}).then(res => {
					console.log(res.data.data)
					this.dataList = res.data.data
					this.td_count = res.data.td_count
					this.zzy_count = res.data.zzy_count
				})
			},
			changeTab() {
				this.getlist()
			},
			showSPDialog(e) {
				this.$http.post("/api/t_sch_stu_apforms_one", {
					stu_id: e.stu_id
				}).then(res => {
					this.formData = res.data
					this.showSP = true
				})

			},
			handleCancel() {},
			checkSubmit(t) {
				this.$confirm('确认审核' + (t == 1 ? '通过' : '不通过') + '?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post("/api/t_sch_stu_apforms_sp", {
						status: t,
						sp_word: this.spword,
						id: this.formData.id
					}).then(res => {
						this.$message({
							type: 'success',
							message: '审核成功!'
						});
						this.getlist()
						this.showSP = false
					})


				}).catch(() => {

				});
			},
			printIframe() {
				console.log(this.formData)
				var iframe = document.getElementById('printPage');
				iframe.contentWindow.focus();
				iframe.contentWindow.print();

			}
		},
	}
</script>


